
import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation('common');

  // 检查当前路径是否匹配导航项
  const isCurrentPath = (currentPath: string, navPath: string) => {
    if (navPath === '/') {
      return currentPath === '/' || currentPath === '/timer';
    }
    if (navPath === '/worldclock') {
      return currentPath.startsWith('/worldclock');
    }
    if (navPath === '/stopwatch') {
      return currentPath === '/stopwatch';
    }
    if (navPath === '/timestamp') {
      return currentPath === '/timestamp';
    }
    return currentPath === navPath || currentPath.startsWith(navPath + '/');
  };

  const navItems = [
    { path: '/', label: t('nav.timer'), icon: 'ri-timer-line' },
    { path: '/stopwatch', label: t('nav.stopwatch'), icon: 'ri-play-circle-line' },
    { path: '/worldclock', label: t('nav.worldclock'), icon: 'ri-global-line' },
    { path: '/timestamp', label: t('nav.timestamp'), icon: 'ri-time-line' }
  ];
  
  return (
    <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link
              to="/"
              className="flex items-center space-x-3 cursor-pointer group"
            >
              <div className="w-10 h-10 bg-white rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-105">
                <img
                  src="/logo.png"
                  alt="timer.today logo"
                  className="w-6 h-6 object-contain"
                />
              </div>
              <h1
                className="font-bold text-white tracking-tight group-hover:text-blue-100 transition-colors duration-300"
                style={{ fontSize: '1.6rem', fontFamily: 'Inter, system-ui, sans-serif' }}
              >
                timer.today
              </h1>
            </Link>
          </div>
          
          {/* 桌面端导航 */}
          <nav className="hidden md:flex space-x-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl transition-all duration-300 whitespace-nowrap transform hover:scale-105 ${
                  isCurrentPath(location.pathname, item.path)
                    ? 'bg-white/20 text-white shadow-lg backdrop-blur-sm'
                    : 'text-blue-100 hover:bg-white/10 hover:text-white hover:shadow-md backdrop-blur-sm'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
                <span className="font-medium">{item.label}</span>
              </Link>
            ))}
          </nav>
          
          {/* 移动端菜单按钮 */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white p-3 rounded-xl hover:bg-white/10 transition-all duration-300 transform hover:scale-105"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
        
        {/* 移动端下拉菜单 */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-white/20 backdrop-blur-sm">
            <div className="py-3 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`w-full flex items-center space-x-3 px-4 py-3 text-left transition-all duration-300 rounded-lg mx-2 ${
                    isCurrentPath(location.pathname, item.path)
                      ? 'bg-white/20 text-white shadow-lg'
                      : 'text-blue-100 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  <i className={`${item.icon} text-lg`}></i>
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
